import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

export default function Card({ className = '', children = null }) {
  const containerClassName = cn(styles.container, className);

  return <div className={containerClassName}>{children}</div>;
}
